// Number and comparison formatting, ported from the design's helpers
// (`f1`, `f0`, `pc`, `dl`). Symptoms are on the API's 1–5 scale, never the
// design's 0–10.

export { bin, mean, pl } from '../../../hormones/core/model/format';

export const GREEN = '#2F7A4D';
export const RED = '#C23B2E';
export const NEUTRAL = '#6b6b6b';
export const AMBER = '#7A4E0E';
export const MUTED = '#8a8a8a';

/** One decimal, always shown ("3.0"); "–" for a missing value. */
export const f1 = (v) => (v == null || Number.isNaN(v) ? '–' : (Math.round(v * 10) / 10).toFixed(1));

/** Whole number with thousands separators; "–" for a missing value. */
export const f0 = (v) => (v == null || Number.isNaN(v) ? '–' : Math.round(v).toLocaleString('en-US'));

/** "64%"; "–" for a missing value. */
export const pc = (v) => (v == null || Number.isNaN(v) ? '–' : `${f0(v)}%`);

/** A value as it was logged: integers bare, anything else to one decimal. */
export const num = (v) => (v == null ? '–' : Number.isInteger(v) ? String(v) : f1(v));

/**
 * The design's `dl`: a change `d` as "↑ 0.4" / "↓ 12" / "No change", with its
 * colour. `dir` is 1 when up is better, −1 when down is better, 0 for neither.
 * @returns {[string, string]}
 */
export function dl(d, dir, fmt) {
  const r = Math.round(d * 10) / 10;
  if (Math.abs(r) < 0.05) return ['No change', NEUTRAL];
  return [`${r > 0 ? '↑ ' : '↓ '}${fmt(Math.abs(r))}`, dir === 0 ? NEUTRAL : (r > 0) === (dir > 0) ? GREEN : RED];
}
